export const isParent = (
  path1: readonly number[],
  path2: readonly number[],
): boolean => {
  if (path1.length >= path2.length) {
    return false;
  }
  for (let i = 0; i < path1.length; i++) {
    if (path1[i] !== path2[i]) {
      return false;
    }
  }
  return true;
};
